import fontFaceObserver from 'fontfaceobserver';

// Masonry
import loadMasonry from '..//masonry/masonry';

export default function fontsLoaded() {
  let font = new fontFaceObserver('Ubuntu');
  let font2 = new fontFaceObserver('Source Sans');

  font.load().then(() => {
    font2.load().then(() => {
      document.documentElement.className += ' fonts-loaded';
      // Load masonry
      loadMasonry();
    });
  })
}
